import { general_File_str } from '@zenlayer/zen-design-icons';
import React from 'react';
import classnames from 'classnames';
import Button from '../button';
import Skeleton from '../skeleton';
import SvgIcon from '../svg-icon';
import { useConfig } from '../hooks/useConfig';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const BasicLayoutHeader = props => {
  const {
    title,
    subtitle,
    extra,
    // onBack,
    initing = false,
    howToUrl,
    whatIsUrl,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style
  } = props;
  const {
    locale: {
      Layout: LayoutLocale
    }
  } = useConfig();
  const baseClassName = "".concat(prefixClass, "-layout-basic--header");
  if (!title && !subtitle && !extra) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
  const howToDom = howToUrl && /*#__PURE__*/_jsx(Button, {
    icon: /*#__PURE__*/_jsx(SvgIcon, {
      svgStr: general_File_str
    }),
    size: "s",
    type: "text",
    onClick: () => {
      window.open(howToUrl);
    },
    children: LayoutLocale.layout_basic_header_howTo
  });
  const whatIsDom = whatIsUrl && /*#__PURE__*/_jsx(Button, {
    icon: /*#__PURE__*/_jsx(SvgIcon, {
      svgStr: general_File_str
    }),
    size: "s",
    type: "text",
    onClick: () => {
      window.open(whatIsUrl);
    },
    children: LayoutLocale.layout_basic_header_whatIs
  });
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(baseClassName, className),
    style: style,
    children: [/*#__PURE__*/_jsx("div", {
      className: "".concat(baseClassName, "--left"),
      children: /*#__PURE__*/_jsx(Skeleton.Node, {
        loading: initing,
        children: /*#__PURE__*/_jsxs("div", {
          className: "title",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "title--main",
            children: [/*#__PURE__*/_jsx("span", {
              children: title
            }), howToDom, whatIsDom]
          }), !!subtitle && /*#__PURE__*/_jsx("div", {
            className: "title--secondary",
            children: subtitle
          })]
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "".concat(baseClassName, "--extra"),
      children: /*#__PURE__*/_jsx(Skeleton.Node, {
        loading: initing,
        children: extra
      })
    })]
  });
};
const BasicLayout = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    title,
    subtitle,
    extra,
    children,
    // onBack,
    initing = false,
    howToUrl,
    whatIsUrl,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style
  } = props;
  const baseClassName = "".concat(prefixClass, "-layout-basic");
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(baseClassName, className),
    style: style,
    ref: ref,
    children: [/*#__PURE__*/_jsx(BasicLayoutHeader, {
      title: title,
      subtitle: subtitle,
      extra: extra
      // onBack={onBack}
      ,
      initing: initing,
      howToUrl: howToUrl,
      whatIsUrl: whatIsUrl
    }), children]
  });
});
export default BasicLayout;